import React, { useEffect, useState } from 'react';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
  TimelineOppositeContent,
} from '@mui/lab';
import {
  Paper,
  Typography,
  Box,
  CircularProgress,
  Chip,
} from '@mui/material';
import { csAdminApi } from '../../../services/api';
const ActivityTab = ({ directorId, activities: initialActivities = [] }) => {
  const [activities, setActivities] = useState(initialActivities);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setActivities(initialActivities);
  }, [initialActivities]);

  useEffect(() => {
    if (!directorId) return undefined;

    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await csAdminApi.getDirectorActivities(directorId, { limit: 100 });
        if (!cancelled) {
          setActivities(res.data?.data || []);
        }
      } catch (_) {
        if (!cancelled) setActivities([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [directorId]);

  const formatDateTime = (timestamp) => {
    if (!timestamp) return '';
    return new Date(timestamp).toLocaleString();
  };

  if (loading && !activities.length) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (!activities || activities.length === 0) {
    return (
      <Box textAlign="center" py={4}>
        <Typography variant="body1" color="textSecondary">
          No activity history available
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
          Profile changes, documents, committee actions, and appointments will appear here.
        </Typography>
      </Box>
    );
  }

  return (
    <Timeline>
      {activities.map((activity, index) => (
        <TimelineItem key={activity.id || index}>
          <TimelineOppositeContent color="textSecondary" sx={{ flex: 0.35 }}>
            {formatDateTime(activity.timestamp)}
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot color={activity.source === 'committee' ? 'secondary' : 'primary'} />
            {index < activities.length - 1 && <TimelineConnector />}
          </TimelineSeparator>
          <TimelineContent>
            <Paper sx={{ p: 2 }}>
              <Typography variant="subtitle2">{activity.description}</Typography>
              {activity.committee && (
                <Chip label={activity.committee} size="small" sx={{ mt: 1, mr: 1 }} />
              )}
              {activity.performedBy && (
                <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 0.5 }}>
                  By: {activity.performedBy}
                </Typography>
              )}
            </Paper>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
};

export default ActivityTab;
